export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',

  // 1. Console
  'menu.dashboard': 'Console',
  'menu.dashboard.workplace': 'Workplace',

  // 2. App Center
  'menu.app': 'App Center',
  'menu.app.mine': 'My Applications',
  'menu.app.appName': 'App',
  'menu.app.mgmt': 'App Management',
  'menu.app.mgmt.list': 'App List',
  'menu.app.mgmt.create': 'Create App',
  'menu.app.mgmt.edit': 'Edit App',
  'menu.app.mgmt.detail': 'App Detail',
  'menu.app.mgmt.analysis': 'App Analytics',
  'menu.app.mgmt.appName': 'App',
  'menu.app.next-chat': 'Chat',
  'menu.app.next-search': 'Search',
  'menu.app.agent': 'Agent',
  'menu.app.memory': 'Memory',

  // 3. Data Center
  'menu.data': 'Data Center',
  'menu.datasets': 'Knowledge Base',
  'menu.data.dataset': 'Knowledge Base',
  'menu.data.dataset.create': 'Create Knowledge',
  'menu.data.dataset.edit': 'Edit Knowledge',
  'menu.data.dataset.detail': 'Knowledge Content Management',
  'menu.data.dataset.detail.file': 'File Preview',
  'menu.data.file': 'File Center',
  'menu.file.preview': 'File Preview',

  // 4. Analytics
  'menu.analysis': 'Analytics',
  'menu.analysis.access': 'Access Reports',
  'menu.analysis.access.login': 'Login Logs',
  'menu.analysis.access.action': 'Operation Audit',
  'menu.analysis.access.app': 'App Usage',
  'menu.analysis.access.app-detail': 'Application Access Details',
  'menu.analysis.access.user-login-detail': 'Login Detail',
  'menu.analysis.audit': 'Permission Audit',
  'menu.analysis.audit.user': 'User Permissions',
  'menu.analysis.audit.role-assign': 'Role Assignments',
  'menu.analysis.audit.role-detail': 'Role Details',
  'menu.analysis.audit.app': 'App Access Permissions',
  'menu.analysis.audit.user-permission-detail': 'User Permission Detail',

  // 5. Organization
  'menu.org': 'Organization',
  'menu.org.user': 'User Management',
  'menu.org.user.permission': 'User Permission Management',
  'menu.org.user.add': 'Add User',
  'menu.org.user.batchImportUser': 'Batch Import Users',
  'menu.org.user.edit': 'Edit User',
  'menu.org.user.detail': 'User Detail',
  'menu.org.role': 'Role Management',
  'menu.org.role.add': 'Add Role',
  'menu.org.role.edit': 'Edit Role',
  'menu.org.role.copy': 'Copy Role',
  'menu.org.company': 'Company Management',
  'menu.org.company.create': 'Create Company',
  'menu.org.company.edit': 'Edit Company',
  'menu.org.company.setting': 'Company Settings',
  'menu.org.dept': 'Dept Management',
  'menu.org.dept.create': 'Create Department',
  'menu.org.dept.edit': 'Edit Department',

  // 6. System Settings
  'menu.system': 'System Settings',
  'menu.system.menu': 'Menu Settings',
  'menu.system.app-config': 'App Configuration',
  'menu.system.data-source': 'Data Source',
  'menu.system.config': 'Global Config',
  'menu.system.license': 'License',
  'menu.system.changelog': 'Changelog',
  'menu.system.info': 'System Info',

  // Others
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.exception': 'Exception',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.403': '403',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',

  // ─── Non-navigation tracking (status toggle / form submit / batch operations) ───
  'menu.org.company.create.submit': 'Create Company - Submit',
  'menu.org.company.edit.submit': 'Edit Company - Submit',
  'menu.org.company.enable': 'Enable Company',
  'menu.org.company.disable': 'Disable Company',
  'menu.org.company.export': 'Company Management - Export',
  'menu.org.dept.create.submit': 'Create Department - Submit',
  'menu.org.dept.edit.submit': 'Edit Department - Submit',
  'menu.org.dept.export': 'Department Management - Export',
  'menu.org.role.add.submit': 'Create Role - Submit',
  'menu.org.role.edit.submit': 'Edit Role - Submit',
  'menu.org.role.copy.submit': 'Copy Role - Submit',
  'menu.org.role.enable': 'Enable Role',
  'menu.org.role.disable': 'Disable Role',
  'menu.org.role.batch_enable': 'Batch Enable Roles',
  'menu.org.role.batch_disable': 'Batch Disable Roles',
  'menu.org.role.export': 'Role Management - Export',
  'menu.org.user.add.submit': 'Create User - Submit',
  'menu.org.user.edit.submit': 'Edit User - Submit',
  'menu.org.user.enable': 'Enable User',
  'menu.org.user.disable': 'Disable User',
  'menu.org.user.copy': 'Copy User',
  'menu.org.user.resetPassword': 'Reset Password',
  'menu.org.user.permission.manager.set': 'User Permission Management - Set Manager',
  'menu.org.user.permission.manager.cancel': 'User Permission Management - Cancel Manager',
  'menu.org.user.permission.resetPassword': 'User Permission Management - Reset Password',
  'menu.org.user.permission.role.add': 'User Permission Management - Add Role',
  'menu.org.user.permission.role.add.submit': 'User Permission Management - Add Role - Submit',
  'menu.org.user.permission.role.remove': 'User Permission Management - Remove Role',
  'menu.org.user.permission.reference': 'User Permission Management - Reference Permission',
  'menu.org.user.permission.reference.submit': 'User Permission Management - Reference Permission - Submit',
  'menu.org.user.permission.customize.submit': 'User Permission Management - Submit Custom Permission',
  'menu.org.user.permission.restore': 'User Permission Management - Restore Default Permission',
  'menu.org.user.export': 'User Management - Export',
  'menu.org.user.print': 'User Management - Print',
  'menu.org.role.print': 'Role Management - Print',
  'menu.org.company.print': 'Company Management - Print',
  'menu.org.dept.print': 'Department Management - Print',
  'menu.analysis.access.action.export': 'Operation Audit - Export',
  'menu.analysis.access.action.print': 'Operation Audit - Print',
  'menu.analysis.access.login.export': 'System Access Report - Export',
  'menu.analysis.access.login.print': 'System Access Report - Print',
  'menu.analysis.access.app.export': 'Application Access Statistics - Export',
  'menu.analysis.access.app.print': 'Application Access Statistics - Print',
  'menu.analysis.access.app-detail.export': 'Application Access Details - Export',
  'menu.analysis.access.app-detail.print': 'Application Access Details - Print',
  'menu.analysis.audit.user.export': 'User Permissions Report - Export',
  'menu.analysis.audit.user.print': 'User Permissions Report - Print',
  'menu.analysis.audit.role-assign.export': 'Role Authorization Report - Export',
  'menu.analysis.audit.role-assign.print': 'Role Authorization Report - Print',
  'menu.analysis.audit.role-detail.export': 'Role Permission Details - Export',
  'menu.analysis.audit.role-detail.print': 'Role Permission Details - Print',
  'menu.analysis.audit.app.export': 'Application Access Report - Export',
  'menu.analysis.audit.app.print': 'Application Access Report - Print',
  'menu.system.menu.edit.submit': 'Menu Settings - Edit Submit',
  'menu.system.menu.drag.submit': 'Menu Settings - Drag Sort',
  'menu.app.mgmt.list.add': 'Create Application',
  'menu.app.mgmt.list.edit': 'Edit Application',
  'menu.app.mgmt.list.config': 'Configure Application',
  'menu.app.mgmt.list.enable': 'Enable Application',
  'menu.app.mgmt.list.disable': 'Disable Application',
  'menu.app.mgmt.list.export': 'Application Management - Export',
  'menu.app.mgmt.list.print': 'Application Management - Print',
};
